import colors from '@/data/colors'
const themeColors = [
  'primary',
  'secondary',
  'accent',
  'error',
  'info',
  'success',
  'warning',
  'muted',
]
const shades = ['black', 'white', 'transparent']

export const colorStringToHex = {
  methods: {
    toCamelCase(str) {
      return str.replace(/\W+(.)/g, (match, chr) => chr.toUpperCase())
    },
    colorStringToHex(colorString) {
      const color = colorString && colorString.length ? colorString.split(' ') : []

      if (themeColors.includes(color[0])) {
        return this.$vuetify.theme[`${this.toCamelCase(color[0])}`]
      }
      if (shades.includes(color[0])) {
        return colors.shades[`${this.toCamelCase(color[0])}`]
      }
      if (color.length === 1) {
        return colors[`${this.toCamelCase(color[0])}`].base
      }
      if (color.length === 2) {
        return colors[`${this.toCamelCase(color[0])}`][`${this.toCamelCase(color[1])}`]
      }
    },
  },
}

export default {
  colorStringToHex,
}
